import { clearConfigCache } from '../services/configApiClient';

/**
 * Limpia la sesión persistente y caché cuando se transiciona
 * entre perfiles de usuario o hacia/desde acceso cliente para evitar contaminación de estado.
 */
export function sanitizeClientSessionState(isEnteringClientMode: boolean): void {
  try {
    // Si se ingresa al modo cliente, limpiamos caché de configuración para forzar catálogo limpio
    clearConfigCache();

    // Limpiar claves temporales de broker que puedan interferir
    sessionStorage.removeItem('broker_filters_cache');
    sessionStorage.removeItem('broker_spatial_filter');

    if (isEnteringClientMode) {
      // Remover cualquier filtro residual guardado de sesión previa
      localStorage.removeItem('broker_dashboard_filters');
    }
  } catch (err) {
    console.warn('[clientSessionSanitizer] Advertencia al sanitizar sesión:', err);
  }
}

/**
 * Obtiene el rol activo garantizado para las cabeceras y llamadas a la API
 */
export function getActiveRoleHeader(isClientMode: boolean, currentUserRole?: string): string {
  if (isClientMode) {
    return 'CLIENTE';
  }
  return (currentUserRole || 'BROKER').toUpperCase();
}
